<script setup lang="ts">
const { _accept, _reject, _alt, isOpen, message, confirmTitle, confirmLabel, confirmDanger, altLabel } =
  useConfirmDialog()
</script>

<template>
  <Teleport to="body">
    <div v-if="isOpen" class="confirm-backdrop" @click.self="_reject">
      <div class="wb-card confirm-card">
        <h3 style="margin: 0 0 10px; font-size: 17px; font-weight: 700">{{ confirmTitle }}</h3>
        <!-- v-text: white-space pre-line must not see template indentation. -->
        <p
          style="margin: 0 0 22px; color: var(--ink-2); line-height: 1.5; font-size: 14px; white-space: pre-line"
          v-text="message"
        />
        <div style="display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap">
          <button class="wb-btn ghost" @click="_reject">Zrušit</button>
          <button v-if="altLabel" class="wb-btn" @click="_alt">{{ altLabel }}</button>
          <button class="wb-btn accent" :class="{ 'confirm-danger': confirmDanger }" @click="_accept">
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(31, 27, 22, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 9999;
}
.confirm-card {
  max-width: 420px;
  width: 100%;
  padding: 28px;
}
.wb-btn.confirm-danger,
.wb-btn.confirm-danger:hover {
  background: var(--error, #c0392b);
  border-color: var(--error, #c0392b);
  color: #fff;
}
</style>
